// Webpack names script-chunk load failures 'ChunkLoadError'; mini-css-extract's
// runtime throws a plain Error whose message matches the CSS variant. Either
// one in production almost always means the tab's index.html predates the
// current deploy and is requesting a content-hash that no longer exists.
export function isStaleChunkError(error) {
    return error.name === 'ChunkLoadError' || /Loading (?:CSS )?chunk .+ failed/i.test(error.message);
}
